import { Layout } from "./components/layout/Layout";
import { VoiceInterface } from "./components/VoiceInterface";
import { Phone, Mic } from "lucide-react";

const VoiceReservation = () => {
  return (
    <Layout>
      <div className="flex flex-col items-center justify-center min-h-[80vh]">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="rounded-full bg-primary/20 p-3">
              <Mic className="h-8 w-8 text-primary" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            Epicware AI Voice Agent
          </h1>
          <p className="text-lg text-muted-foreground max-w-xl">
            Experience our AI-powered restaurant receptionist. Make reservations, 
            ask about menu items, or inquire about our hours.
          </p>
        </div>

        {/* Voice Interface */}
        <VoiceInterface />

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16 w-full max-w-4xl">
          <div className="rounded-xl border border-border bg-card p-6 text-center">
            <Phone className="h-8 w-8 text-primary mx-auto mb-3" />
            <h3 className="font-semibold text-card-foreground mb-2">Voice Enabled</h3>
            <p className="text-sm text-muted-foreground">
              Natural conversation with real-time voice interaction
            </p>
          </div>
          <div className="rounded-xl border border-border bg-card p-6 text-center">
            <svg className="h-8 w-8 text-primary mx-auto mb-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            <h3 className="font-semibold text-card-foreground mb-2">Smart Reservations</h3>
            <p className="text-sm text-muted-foreground">
              Book tables instantly with email confirmations
            </p>
          </div>
          <div className="rounded-xl border border-border bg-card p-6 text-center">
            <svg className="h-8 w-8 text-primary mx-auto mb-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12,6 12,12 16,14"/>
            </svg>
            <h3 className="font-semibold text-card-foreground mb-2">24/7 Available</h3>
            <p className="text-sm text-muted-foreground">
              Always ready to help your customers
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default VoiceReservation;
